import { LabelChip, TruncatedText } from "@carbon6/c6-frontend-design";
import { formatDateTime } from "@/shared/utils/datetime/format";
import { formatDatasetFormat } from "../feature/datasetFormatters";
import type { CandidateTableRow } from "./CandidateTableRow";
import styles from "./datasetColumns.module.css";
import type { DataTableColumn } from "@carbon6/c6-frontend-design";

/**
 * Scanned Results 페이지의 컬럼.
 *
 * 후보에는 아직 이름이 없다. 주소가 이름을 대신하므로 주소 칸이 가장 넓다. 포맷 칩은 서버의
 * `canProbe` 로 모양(채움 또는 외곽선)을 정한다. 사용자는 "수락하면 바로 Probe 할 수 있다" 와
 * "보기만 된다" 를 한눈에 구분한다. 판정 근거는 옆 칸에 둔다.
 */
export const candidateColumns: readonly DataTableColumn<CandidateTableRow>[] = [
  {
    key: "sourceRef",
    header: "원본 주소",
    width: "minmax(18rem, 3fr)",
    sortable: "both",
    render: (row) => <TruncatedText className={styles.sourceCell}>{row.sourceRef}</TruncatedText>,
  },
  {
    key: "format",
    header: "포맷",
    width: "10rem",
    sortable: "both",
    // 포맷은 상태가 아니라 분류다 — 상태 어휘(`StatusChip`)를 빌려 쓰지 않는다.
    render: (row) => (
      <LabelChip
        color={row.canProbe ? 0 : 1}
        size="sm"
        variant={row.canProbe ? "filled" : "outline"}
      >
        {formatDatasetFormat(row.format, row.formatVersion)}
      </LabelChip>
    ),
  },
  {
    key: "formatDetail",
    header: "판정 근거",
    width: "minmax(12rem, 2fr)",
    // 근거가 없는 후보(바로 Probe 할 수 있는 후보)는 칸을 비운다. 줄마다 "없음" 을 적으면 읽을 글이 는다.
    render: (row) =>
      row.formatDetail === null ? null : <TruncatedText>{row.formatDetail}</TruncatedText>,
  },
  {
    key: "rootCode",
    header: "루트",
    width: "9rem",
    sortable: "both",
    render: (row) => row.rootCode,
  },
  {
    key: "firstSeenAtMs",
    header: "처음 본 시각",
    width: "11rem",
    sortable: "both",
    render: (row) => formatDateTime(row.firstSeenAtMs),
  },
  {
    key: "lastSeenAtMs",
    header: "마지막 본 시각",
    width: "11rem",
    sortable: "both",
    render: (row) => formatDateTime(row.lastSeenAtMs),
  },
];

/** 초기 정렬 — 최근에 발견된 것이 위다. */
export const candidateInitialSort = { columnKey: "firstSeenAtMs", direction: "desc" } as const;
